module.exports = __webpack_public_path__ + "media/images/flags/4x3/cri-b9e32234f4c4b9d4d23c68eacd9bb1ff.svg";